import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdminOptionalSubjectPopupComponent } from '../admin-optional-subject-popup/admin-optional-subject-popup.component';

@Component({
  selector: 'app-admin-optional-subject-selection',
  templateUrl: './admin-optional-subject-selection.component.html',
  styleUrls: ['./admin-optional-subject-selection.component.scss']
})
export class AdminOptionalSubjectSelectionComponent implements OnInit {
  studentFilterForm: FormGroup;
  studentDataList: any[] = [];
  courseList: any[] = [];
  filteredCourseList: any[] = [];
  examList: any[] = [];
  filteredExamList: any[] = [];

  userPermission: any;
  userCollege: any;

  pageSize = 10;
  pageSizeOptions = [5, 10, 20, 50];
  currentPage = 1;
  totalItems = 0;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    public umsService: UmsService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem('userPermission'));
    this.userCollege = this.userPermission?.[0]?.CgUi === 'C' ? this.userPermission[0].CgId : '';

    this.studentFilterForm = this.fb.group({
      CoCode: new FormControl(''),
      exam: new FormControl(0),
      SearchString: new FormControl('')
    });

    this.fetchCourses();
    this.getStudentData();
  }

  fetchCourses() {
    this.spinner.show();
    this.umsService.getCourse({}).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.courseList = res.data;
        this.filteredCourseList = [...this.courseList];
      }
    });
  }

  onCourseChange(courseCode: number) {
    this.studentFilterForm.patchValue({ exam: 0 });
    if (!courseCode) {
      this.examList = [];
      this.filteredExamList = [];
      return;
    }
    this.spinner.show();
    const payload = { EmCoCode: courseCode };
    this.umsService.getExam(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        const allOption = { EmId: 0, EmName: 'ALL', EmCoCode: '' };
        this.examList = [allOption, ...res.data];
        this.filteredExamList = [...this.examList];
        this.studentFilterForm.patchValue({ exam: 0 });
      }
    }, () => {
      this.spinner.hide();
      this.examList = [];
    });
  }

  getStudentData() {
    this.spinner.show();
    const payload: any = {
      PageSize: this.pageSize,
      PageNumber: this.currentPage,
      CgCode: this.userCollege,
      CoCode: this.studentFilterForm.value.CoCode || '',
      EmId: this.studentFilterForm.value.exam || '',
      SearchString: this.studentFilterForm.value.SearchString || ''
    };
    this.umsService.StudentFetchForOptionalSubject(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          const studentList = res.data;
          studentList.forEach((student: any) => {
            const course = this.courseList.find(c => c.CoCode === student.CourseCode);
            student.CoName = course ? course.CoName : student.CourseCode || 'N/A';
          });
          this.studentDataList = studentList;
          this.totalItems = studentList[0]?.TotalRecords || 0;
        } else {
          this.studentDataList = [];
          this.totalItems = 0;
        }
      },
      () => {
        this.spinner.hide();
        this.studentDataList = [];
        this.totalItems = 0;
      }
    );
  }

  onSearchEnter(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.currentPage = 1;
      this.getStudentData();
      event.preventDefault();
    }
  }

  clearSearch() {
    this.studentFilterForm.get('SearchString')?.setValue('');
    this.currentPage = 1;
    this.getStudentData();
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex + 1;
    this.getStudentData();
  }

  openOptionalSubjectPopup(student: any) {
    const dialogRef = this.dialog.open(AdminOptionalSubjectPopupComponent, {
      width: '90%',
      maxWidth: '1200px',
      height: '90%',
      data: { student: student },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.getStudentData();
    });
  }
}